import { useFirstActivationDateMs } from '@atlassian/jira-tenant-context-controller';
import { isWithinLast30Days } from '../../utils';

export const useIsFirstActivationDateWithinLast30Days = () => {
	const firstActivationDate = useFirstActivationDateMs();
	return isWithinLast30Days(firstActivationDate);
};
